import React, { useState, useEffect } from 'react';
import { evenementService } from '../../../api';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './evenements.css';
import Sidebar from '../sidebar/Sidebar';
import { Link, useNavigate } from 'react-router-dom';

const Evenements = () => {
  const [evenements, setEvenements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    fetchEvenements();
  }, [currentPage]);

  const fetchEvenements = async () => {
    try {
      setLoading(true);
      const response = await evenementService.getAll(currentPage);
      console.log('Réponse API:', response); // Debug

      const eventsData = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : [];

      setEvenements(eventsData);
      setTotalPages(response?.meta?.last_page || response?.last_page || 1);
      setError(null);
    } catch (err) {
      console.error('Erreur complète:', err);
      setError(err.response?.data?.message || 'Erreur lors du chargement des événements');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
  confirmAlert({
    title: 'Confirmer la suppression',
    message: 'Êtes-vous sûr de vouloir supprimer cet événement ?',
    buttons: [
      {
        label: 'Oui',
        onClick: async () => {
          try {
            setLoading(true);
            setError(null);
            
            const result = await evenementService.delete(id);
            console.log('Résultat suppression:', result); // Debug
            
            if (result?.success) {
              setSuccessMessage(result.message || 'Événement supprimé avec succès');
              setEvenements(prev => prev.filter(event => event.id !== id));
              
              // Si c'était le dernier élément de la page, revenir à la page précédente
              if (evenements.length === 1 && currentPage > 1) {
                setCurrentPage(currentPage - 1);
              }
            } else {
              setError(result?.message || 'Erreur lors de la suppression');
            }
          } catch (err) {
            console.error('Erreur détaillée:', {
              message: err.message,
              status: err.status,
              data: err.data
            });
            
            setError(err.message || 'Erreur serveur lors de la suppression');
          } finally {
            setLoading(false);
            setTimeout(() => {
              setSuccessMessage(null);
              setError(null);
            }, 5000);
          }
        }
      },
      {
        label: 'Non'
      }
    ]
  });
};

  const handleEdit = (id) => {
    navigate(`/admin/evenements/modifier/${id}`);
  };

  const formatDate = (dateString) => {
    try {
      const options = { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      };
      return new Date(dateString).toLocaleDateString('fr-FR', options);
    } catch {
      return dateString;
    }
  };

  const formatPrix = (prix) => {
    return prix ? `${parseFloat(prix).toFixed(2)} €` : 'Gratuit';
  };

  return (
    <div className="evenements-wrapper">
      <Sidebar />
      <div className="evenements-container">
        <Link to="/admin/evenements/ajouter" className="add-button">
          Ajouter un événement
        </Link>
        <h2>Gestion des événements</h2>
        
        {error && (
          <div className="error-message">
            {error}
            <button onClick={() => setError(null)} className="close-error">×</button>
          </div>
        )}
        
        {successMessage && (
          <div className="success-message">
            {successMessage}
            <button onClick={() => setSuccessMessage(null)} className="close-success">×</button>
          </div>
        )}
        
        {loading ? (
          <div className="loading">Chargement en cours...</div>
        ) : (
          <>
            <table className="evenements-table">
              <thead>
                <tr>
                  <th>Titre</th>
                  <th>Description</th>
                  <th>Lieu</th>
                  <th>Date</th>
                  <th>Prix</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {evenements.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="no-events">
                      Aucun événement trouvé.
                    </td>
                  </tr>
                ) : (
                  evenements.map((evenement) => (
                    <tr key={evenement.id}>
                      <td>{evenement.titre}</td>
                      <td className="description-cell">
                        {evenement.description?.length > 50 
                          ? `${evenement.description.substring(0, 50)}...` 
                          : evenement.description}
                      </td>
                      <td>{evenement.lieu}</td>
                      <td>{formatDate(evenement.date)}</td>
                      <td>{formatPrix(evenement.prix)}</td>
                      <td className="actions-cell">
                        <button 
                          className="edit-btn" 
                          onClick={() => handleEdit(evenement.id)}
                          title="Modifier"
                        >
                          <FaEdit />
                        </button>
                        <button 
                          className="delete-btn" 
                          onClick={() => handleDelete(evenement.id)}
                          title="Supprimer"
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {totalPages > 1 && (
              <div className="pagination">
                <button 
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(p => p - 1)}
                >
                  Précédent
                </button>
                <span>Page {currentPage} sur {totalPages}</span>
                <button 
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(p => p + 1)}
                >
                  Suivant
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Evenements;